import { Component, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormControl, FormGroupDirective, Validators } from '@angular/forms';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';

@Component({
  selector: 'step-time-frame',
  templateUrl: '../../step/button-step/button-step.component.html',
  styleUrls: ['../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})

export class TimeFrameComponent extends ButtonStepComponent implements OnInit {
  title: string = "When do you need the money?";

  ngOnInit() {    
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('timeFrame', this.control);
    // this.analyticsService.trackQuestionShown('timeFrame');
  }

  buttonList = [
    { text: 'Within 48 hours', value: '48h', imageName: '48hours', default: true },
    { text: 'Within 2 weeks', value: '2w', imageName: '2weeks' },
    { text: 'Within a month', value: 'm', imageName: 'month' },
    { text: 'Unsure', value: 'no', imageName: 'unsure-time' },
  ];
}
